import { validateOthercamsForm } from './forms/othercams';

function reopenCollapsibles(form: HTMLFormElement): void {
    const collapsedElements: NodeListOf<HTMLDivElement> = form.querySelectorAll('.collapsible');

    collapsedElements.forEach((element: HTMLDivElement) => {
        const selectElements: NodeListOf<HTMLSelectElement> = element.querySelectorAll('select');
        let isCollapsibleOpened = false;

        selectElements.forEach((select: HTMLSelectElement) => {
            if (select.value && !isCollapsibleOpened) {
                const parent: HTMLElement | null = select.closest('.collapsible');
                const previousElement: Element | null | undefined = parent?.previousElementSibling;

                if (previousElement instanceof HTMLElement) {
                    previousElement.click();
                }

                isCollapsibleOpened = true;
            }
        });
    });
}

function attachSearchEvents(form: string): void {
    const searchForm: HTMLFormElement | null = document.querySelector(form);

    if (searchForm) {
        validateOthercamsForm(searchForm);
        reopenCollapsibles(searchForm);
    }
}

attachSearchEvents('.js-search-form');
